import AIAnalysis from '../../../components/RichInsights/AIAnalysis';
import { Row, Col } from 'reactstrap';
import { PersonaVisualizations } from '../../../views/personas/home/Visualizations';
import QueryInput, { CustomerSummary, TopConvertingProducts } from '../../../views/personas/QueryInput';
import { useParams } from 'react-router-dom'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export default function CustomerDetail() {
  const params = useParams();
  const personaId = params.personaId;
  const knowledge = useSelector(state => state.knowledge);

  const activeEntity = useMemo(() => {
    if (knowledge.entities) {
      return knowledge.entities.find(entity => entity.id === personaId);
    }

    return null;
  }, [knowledge.entities, personaId]);

  console.log('ACTIVE ENTITY: ', activeEntity);

  return (
    <div
      className="customer-detail"
      style={{
        width: '100% !important',
        display: 'flex',
        flexDirection: 'column',
        gap: '32px'
      }}
    >
      <Row style={{ margin: '16px 0 0' }}>
        <Col>
          <div className="bg-gradient-primary border-0" style={{ padding: '24px' }}>
            <h1 style={{ color: 'white', boxSizing: 'border-box', width: '100%' }}>{activeEntity.name}</h1>
          </div>
        </Col>
      </Row>
      <Row style={{ margin: '0 0 32px' }}>
        <Col className="col-4">
          <CustomerSummary />
          <TopConvertingProducts />
        </Col>
        <Col className="col-8">
          <QueryInput />
          <AIAnalysis />
        </Col>
      </Row>

      <PersonaVisualizations />
    </div>
  );
}
